module.exports = __webpack_public_path__ + "static/img/coe-4ton-green.d1410fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-green.svg
// module id = zAJt
// module chunks = 74